module.exports = __webpack_public_path__ + "img/1745896043_tTp9.b818b679.png";